import { render, staticRenderFns } from "./bv-page-list.vue?vue&type=template&id=7d4e9784&scoped=true&"
import script from "./bv-page-list.vue?vue&type=script&lang=js&"
export * from "./bv-page-list.vue?vue&type=script&lang=js&"
import style0 from "./bv-page-list.vue?vue&type=style&index=0&id=7d4e9784&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../apps/life_driving_school/node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4e9784",
  null
  
)

export default component.exports